import { useForm } from "react-hook-form";
import { useNavigate, Link } from "react-router-dom";
import toast from "react-hot-toast";
import authService from "../../services/authService";
import styles from "./Forgot.module.css";
import { useState } from "react";
export default function ForgotPassword() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();
 const onSubmit = async (data) => {
    setLoading(true);
    try {
        await authService.requestPasswordResetOtp(data.login);
        toast.success("Password reset OTP sent successfully");
        navigate("/reset-password", {
            state: { login: data.login },
        });
    } catch (err) {
        toast.error(
            err?.response?.data?.message || "Failed to send OTP"
        );
    } finally {
        setLoading(false);
    }
};
    return (
        <div className={styles.authWrapper}>
            <div className={styles.card}>

                {/* LOGO */}
                <div className={styles.logo}>
                    <Link to="/" className="app-brand-link gap-2">
                        {/* <img src="VITAURA" alt="Logo" /> */}
                          {/* <h2 style={{color:"#FB6C22",textAlign:"center"}}>VITAURA</h2> */}
                          <img
  src="vitauralogo.jpg"
  alt="Vitaura Logo"
  style={{
    width: "220px",
    height: "80px",
    objectFit: "contain",
    display: "block",
    margin: "0 auto",
  }}
/>
                    </Link>
                </div>
                <h4 className={styles.title}>Forgot Password 🔐</h4>

                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className={styles.formGroup}>
                        <label>Enter Email or Phone Number :</label>
                        <input
                            type="text"
                            placeholder="Email or phone number"
                            {...register("login", {
                                required: "This field is required",
                            })}
                        />
                        {errors.login && (
                            <span className={styles.error}>
                                {errors.login.message}
                            </span>
                        )}
                    </div>

                    <button type="submit" className={styles.primaryBtn} disabled={loading}>
    {loading ? "Sending..." : "Send OTP"}
</button>
                </form>
                <div className="d-flex justify-content-center mt-3">
                    Remembered your password ? <Link to="/login">
                        <large className="ml-3" style={{color:"#FB6C22"}}> Login</large>
                    </Link>
                </div>

            </div>
        </div>
    );
}